export default __webpack_public_path__ + "static/drumKit-8887bdd1a15590e2f2b6b8c1916ba8fa.svg";